import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="static-page legal-page">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last Updated: January 2024</p>

      <section>
        <h2>1. Information We Collect</h2>
        <p>We collect the following information:</p>
        <ul>
          <li>Name and email address (for order delivery)</li>
          <li>Payment information (processed by Plisio)</li>
          <li>Order history</li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Process and deliver your orders</li>
          <li>Send order confirmations</li>
          <li>Provide customer support</li>
          <li>Improve our services</li>
        </ul>
      </section>

      <section>
        <h2>3. Data Security</h2>
        <p>
          We use industry-standard encryption and security measures to protect your data. 
          Payment information is processed securely through Plisio and never stored on our servers.
        </p>
      </section>

      <section>
        <h2>4. Data Sharing</h2>
        <p>
          We do not sell or share your personal information with third parties except:
        </p>
        <ul>
          <li>Payment processor (Plisio) for transaction processing</li>
          <li>When required by law</li>
        </ul>
      </section>

      <section>
        <h2>5. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Request data deletion</li>
          <li>Opt-out of marketing emails</li>
        </ul>
      </section>

      <section>
        <h2>6. Cookies</h2>
        <p>
          We use cookies to improve your browsing experience and remember your cart items.
        </p>
      </section>

      <section>
        <h2>7. Contact</h2>
        <p>For privacy concerns, email us at iwantcheats.store@gmail.com</p>
      </section>
    </div>
  );
};

export default PrivacyPage;
